
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.textfield-typeahead-wrapper {
  position: relative;
  font-family: var(--slh-default-font-family, "Open Sans");
}
.textfield-typeahead-wrapper .typeahead-options-wrapper {
  position: absolute;
  top: 48px;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 112px;
  overflow-y: auto;
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  border-radius: 8px;
  margin: 0;
  padding: 8px 16px;
  display: none;
  box-sizing: border-box;
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  /* Track */
  /* Handle */
}
.textfield-typeahead-wrapper .typeahead-options-wrapper::-webkit-scrollbar {
  width: 6px;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper::-webkit-scrollbar-track {
  background: var(--slh-color-neutral-shade-10, #F6F7FA);
}
.textfield-typeahead-wrapper .typeahead-options-wrapper::-webkit-scrollbar-thumb {
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
  border-radius: 6px;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.textfield-typeahead-wrapper .typeahead-options-wrapper.loading {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper.loading .loader {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--slh-color-primary, #3B87D4);
  color: var(--slh-color-primary, #3B87D4);
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper.loading .loader::before, .textfield-typeahead-wrapper .typeahead-options-wrapper.loading .loader::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper.loading .loader::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--slh-color-primary, #3B87D4);
  color: var(--slh-color-primary, #3B87D4);
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper.loading .loader::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--slh-color-primary, #3B87D4);
  color: var(--slh-color-primary, #3B87D4);
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}
.textfield-typeahead-wrapper .typeahead-options-wrapper.has-label {
  top: 72px;
}
.textfield-typeahead-wrapper span.highlight {
  font-weight: var(--slh-base-bold-font-weight, 700);
  color: var(--slh-color-neutral, #39455D);
}
.textfield-typeahead-wrapper .hint-wrapper {
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-bottom: -8px;
}
.textfield-typeahead-wrapper .hint-wrapper .hint-icon-container {
  margin-top: 4px;
  padding-right: 4px;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
}
.textfield-typeahead-wrapper .hint-wrapper * {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh--base-xxs-font-size, 12px);
  font-weight: var(--slh--base-bold-font-weight, 700);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
}
.textfield-typeahead-wrapper .hint-wrapper.hidden {
  display: none;
}

@keyframes dotFlashing {
  0% {
    background-color: var(--slh-color-primary, #3B87D4);
  }
  50%, 100% {
    background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  }
}
`;
